<div class="nav-layout">
  <tehw0lf-desktop></tehw0lf-desktop>
  <tehw0lf-mobile></tehw0lf-mobile>
</div>
